import { useQuery } from '@tanstack/react-query'
import {
  type IndustryCategoryEnum,
  type IndustryTemplate,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { industryTemplatesQueryKeys } from './queryKeys'

type UseQueryIndustryTemplatesParams = {
  industry: IndustryCategoryEnum
  key?: string
  enabled: boolean
}

export const useQueryIndustryTemplates = ({
  industry,
  key,
  enabled,
}: UseQueryIndustryTemplatesParams) => {
  return useQuery({
    queryKey: industryTemplatesQueryKeys.byIndustry(industry, key),
    queryFn: async (): Promise<IndustryTemplate[]> => {
      const response = await baseClient
        .getApi(TemplatesApi)
        .getIndustryTemplates({ industry, key })
      return response.industryTemplates
    },
    enabled,
  })
}
